module.exports = __webpack_public_path__ + "static/img/intersfour.d9eb2df.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/intersfour.png
// module id = gdhj
// module chunks = 45